import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { SearchableSelect } from '../../components/SearchableSelect';
import { sports } from '../../data/sports';
import type { OnboardingStepProps } from '../types';

// Step 2: sport selection. Searchable dropdown sorted alphabetically by the
// translated label using the active UI locale, with "Other" pinned last.

export function Sport({ draft, update }: OnboardingStepProps) {
  const { t, i18n } = useTranslation('common');

  const options = useMemo(() => {
    const labelled = sports.map((s) => ({ value: s.code, label: t(s.i18nKey) }));
    const collator = new Intl.Collator(i18n.language, { sensitivity: 'base' });
    return labelled.sort((a, b) => {
      if (a.value === 'other') return 1;
      if (b.value === 'other') return -1;
      return collator.compare(a.label, b.label);
    });
  }, [t, i18n.language]);

  return (
    <div className="form">
      <SearchableSelect
        labelKey="onboarding.sport.label"
        placeholderKey="onboarding.sport.placeholder"
        value={draft.sportCode}
        options={options}
        onChange={(code) => update({ sportCode: code })}
        required
      />
      <p className="form__hint">{t('onboarding.sport.hint')}</p>
    </div>
  );
}

export const sportIsValid = (draft: { sportCode: string }): boolean =>
  draft.sportCode.trim().length > 0;
